// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BZWQ","footer":"styles_footer__3j13o"};